export const SEARCH_DEBOUNCE_MS = 1500; // 1.5 seconds - wait for user to stop typing
export const SEARCH_STALE_TIME = 1000 * 60 * 2; // 2 minutes
export const MIN_SEARCH_LENGTH = 2;
export const MAX_RESULTS = 25;
export const MAX_RECENT_SEARCHES = 5;

export const KEYBOARD_SHORTCUTS = {
  toggle: {
    mac: "\u2318K",
    windows: "Ctrl+K",
  },
  close: "Esc",
  navigate: "\u2191\u2193",
  select: "\u21B5",
} as const;
